// extracted by mini-css-extract-plugin
export default {"container":"AffiliateLink_container__aNY1u","label":"AffiliateLink_label__pl2mP","massage":"AffiliateLink_massage__IfhAR"};